var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrcode = function SvgQrcode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.143 2v6.857H18V2h-6.857zm4.571 4.571h-2.286V4.286h2.286v2.285zM2 18h6.857v-6.857H2V18zm2.286-4.571h2.286v2.286H4.286v-2.286zM16.857 12.286h-2.286v-1.143h-3.428V18h2.286v-3.429h1.142v1.143H18v-4.571h-1.143zM16.857 16.857H18V18h-1.143z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.571 16.857h1.143V18h-1.143zM2 8.857h6.857V2H2v6.857zm2.286-4.571h2.286v2.286H4.286V4.286z"
  })));
};
export default SvgQrcode;